export default __webpack_public_path__ + "static/media/editable.1565194c.svg";